var $JQ = jQuery.noConflict(),
    actClass = 'zn-active';

var breakpoint = {
	"s": 400,
	"m": 768,
	"l": 1024,
	"xl": 1200,
	"full": 1440,
};